import './fix-ie10-below-extend-bug';



// WEBPACK FOOTER //
// ./src/polyfill/index.js